import React from "react";

export const AddressIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<path
				d="M6,0C2.9,0,0,2.3,0,5.1C0,7.9,2.6,11.2,6,16c3.4-4.8,6-8.1,6-10.9C12,2.3,9.1,0,6,0z M6,7.3
c-1.2,0-2.3-0.9-2.3-2s1-2,2.3-2s2.3,0.9,2.3,2S7.2,7.3,6,7.3z"
			/>
		</svg>
	);
};

export const AgreeIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<polygon
				className="st0"
				points="5,6.2 3.6,7.6 6.8,10.8 6.8,10.8 8.1,12.2 16,4.2 14.6,2.8 8.1,9.4 "
			/>
			<polygon
				className="st0"
				points="12.8,14 2,14 2,3 11.8,3 11.8,1 2,1 0,1 0,3 0,14 0,16 2,16 12.8,16 14.7,16 14.7,14 14.7,9 12.8,9 "
			/>
		</svg>
	);
};

export const FileIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<polygon
				className="st0"
				points="14,10 14,14 2,14 2,10 0,10 0,14 0,16 2,16 14,16 16,16 16,14 16,10 "
			/>
			<polygon className="st0" points="8,11 12,6.8 9,6.8 9,0 7,0 7,6.8 4,6.8 " />
		</svg>
	);
};

export const LinkIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<path
				className="st0"
				d="M6.8,12.4l-0.9,0.9c-0.9,0.9-2.3,0.9-3.2,0s-0.9-2.3,0-3.2l2.9-2.9C5.9,7,6.3,6.8,6.7,6.7C7.7,6.4,8.8,7,9.2,8
l1.5-1.5C9.5,4.6,7,4,5.1,5.1c-0.3,0.2-0.7,0.4-1,0.7L1.3,8.7c-1.7,1.7-1.7,4.4,0,6.1c1.7,1.7,4.4,1.7,6.1,0l2-2
C8.4,12.9,7.6,12.7,6.8,12.4z"
			/>
			<path
				className="st0"
				d="M14.7,1.3c-1.7-1.7-4.4-1.7-6.1,0l-2,2c0.9-0.1,1.7,0.1,2.5,0.4L10,2.8c0.9-0.9,2.3-0.9,3.2,0s0.9,2.3,0,3.2
l-2.9,2.9C9.4,9.8,8,9.8,7.1,8.9c0-0.4-0.2-0.6-0.3-0.9L5.3,9.5c0.2,0.2,0.3,0.4,0.5,0.7c0.5,0.5,1.2,0.9,2,1.1
c1,0.2,2.1,0.1,3.1-0.4c0.3-0.2,0.7-0.4,1-0.7l2.9-2.9C16.4,5.6,16.4,2.9,14.7,1.3z"
			/>
		</svg>
	);
};

export const LongTextIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<rect y="1" className="st0" width="16" height="2" />
			<rect y="5" className="st0" width="16" height="2" />
			<rect y="9" className="st0" width="16" height="2" />
			<rect y="13" className="st0" width="10" height="2" />
		</svg>
	);
};

export const PlusIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="34"
			height="34"
			viewBox="0 0 34 34"
			className=""
		>
			<polygon
				className="st0"
				points="24,16 18,16 18,10 16,10 16,16 10,16 10,18 16,18 16,24 18,24 18,18 24,18 "
			/>
		</svg>
	);
};

export const RadioIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<path className="st0" d="M14,2H8H0v2v7v2h8h6h2v-2V4V2H14z M14,11H8V4h6V11z" />
		</svg>
	);
};

export const SelectIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<rect x="9" y="5" className="st0" width="7" height="2" />
			<rect x="9" y="14" className="st0" width="7" height="2" />
			<path className="st0" d="M2,0H0v2v3v2h2h3h2V5V2V0H5H2z M5,5H2V2h3V5z" />
			<path className="st0" d="M2,9H0v2v3v2h2h3h2v-2v-3V9H5H2z M5,14H2v-3h3V14z" />
		</svg>
	);
};

export const ShortTextIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<rect y="5" className="st0" width="16" height="2" />
			<rect y="9" className="st0" width="10" height="2" />
		</svg>
	);
};

export const TagIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<g>
				<path d="M7.1,0H0v7.1L8.9,16L16,8.9L7.1,0z M1.3,6.5V1.3h5.2l7.6,7.6l-5.2,5.2L1.3,6.5z" />
				<path
					d="M4.3,2.7c-0.4,0-0.9,0.2-1.2,0.5c-0.7,0.7-0.7,1.7,0,2.4C3.5,5.8,3.9,6,4.3,6s0.9-0.2,1.2-0.5
    c0.7-0.7,0.7-1.7,0-2.4C5.2,2.8,4.8,2.7,4.3,2.7z"
				/>
			</g>
		</svg>
	);
};

export const WritingIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			className="format-icon"
		>
			<rect x="2.7" y="11.1" className="st0" width="2.7" height="0.8" />
			<polygon
				className="st0"
				points="14,14.1 2,14.1 2,1.9 10,1.9 10,0 2,0 0,0 0,1.9 0,14.1 0,15.1 0,16 14,16 16,16 16,14.1"
			/>
			<polygon className="st0" points="6.2,11.9 9.1,11.4 6.8,9.2 " />
			<polygon className="st0" points="9.7,10.8 16,4.9 13.7,2.7 7.4,8.6 " />
		</svg>
	);
};

export const CalenderIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 612 560"
			className="format-icon"
		>
			<path
				d="M509.999,457.682H408v-101.82h101.999V457.682z M357,203.137H255v101.817h102V203.137z M509.999,203.137H408
	v101.817h101.999V203.137z M203.999,355.862H102v101.819h101.999V355.862z M612-0.5v560H0v-560H612z M561,152.228H51v356.363h510
	V152.228z M357,355.862H255v101.819h102V355.862z M203.999,203.137H102v101.817h101.999V203.137z"
			/>
		</svg>
	);
};

export const DropdownIcon = () => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="format-icon"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.5 1.5H14.5V14.5H1.5V1.5ZM0 16V0H16V16H0ZM8 10L5 7H11L8 10Z"
			/>
		</svg>
	);
};

export const MultiCheckboxIcon = () => {
	return (
		<svg
			width="18"
			height="18"
			viewBox="0 0 18 18"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className="format-icon"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M17.4996 0.5H3.6123V4.09155H0.5V17.5H13.9085V14.3873H17.4996V0.5ZM13.9085 12.9507H16.063V1.93662H5.04892V4.09155H13.9085V12.9507ZM12.4718 5.52817H1.93662V16.0634H12.4718V5.52817ZM9.5696 8.37241L10.5854 9.38826L6.24653 13.7272L3.82312 11.3038L4.83896 10.2879L6.24653 11.6955L9.5696 8.37241Z"
			/>
		</svg>
	);
};
